import React from 'react';
import { IconInput } from 'app/shared/input';
import { LinkButton } from 'app/shared/button';
import { DetailItem } from 'app/shared/info-section/item';
import styles from '../create.module.css';

/**
 * A dark field that carries an inline verification affordance: a "verify" link
 * while the value is complete-but-unverified, a busy label while in flight, a
 * lock notice once attempts are exhausted, and a green check once verified.
 */
export const VerifiableField = ({
  title,
  type = 'text',
  value,
  onChange,
  error,
  verified,
  verifying,
  verifyingText = 'Verifying…',
  verifyLabel,
  onVerify,
  showVerify,
  locked = false,
  attemptsLeft = null
}) => (
  <DetailItem dark title={title} required>
    <IconInput
      dark
      type={type}
      value={value}
      onInput={onChange}
      error={error}
      icon_name={verified ? 'check_circle' : ''}
      icon_position="right"
      iconClassName={styles.verifiedIcon}
    />
    {showVerify && !verified && (
      <div className={styles.verifyRow}>
        {verifying ? (
          <span className={styles.verifyingText}>{verifyingText}</span>
        ) : locked ? (
          <span className={styles.lockedText}>Maximum attempts reached. Contact support.</span>
        ) : (
          <>
            <LinkButton className={styles.verifyLink} text={verifyLabel} onClick={onVerify} />
            {attemptsLeft != null && (
              <span className={styles.attemptsText}>
                {attemptsLeft} {attemptsLeft === 1 ? 'attempt' : 'attempts'} left
              </span>
            )}
          </>
        )}
      </div>
    )}
  </DetailItem>
);
